import { utcToJSDate } from "@/utils/date-time";
import { SubscriptionDurationEnum, SubscriptionPlan, SubscriptionTierEnum } from "./subscription-plan.model";
import { PaginationFilterRequest } from "./core.model";

export function subscriptionCodeFromJson<SubscriptionCode> (json: any): SubscriptionCode {
  return {
    ...json,
    startDate: utcToJSDate(json.startDate)!,
    endDate: json.endDate ? utcToJSDate(json.endDate)! : undefined
  } as SubscriptionCode;
};

export interface SubscriptionCode {
    id: number;
    subscriptionPlanId?: number;
    code: string;
    maxUses: number;
    usesCount: number;
    startDate: Date;
    endDate?: Date;
    isActive: boolean;
    subscriptionPlan?: SubscriptionPlan;    
}

export interface UpsertSubscriptionCode {
    id?: number;
    subscriptionPlanId?: number;
    code?: string;
    maxUses?: number;
    usesCount?: number;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
}

export class SubscriptionCodePaginationFilterRequest extends PaginationFilterRequest{  
    subscriptionPlanId?: number;
    onlyActive?: boolean;
    tier?: SubscriptionTierEnum;
    duration?: SubscriptionDurationEnum;
}